export default "__VITE_ASSET__EBkYfRti__"